import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal">
      <div className="legal__inner">
        <Link to="/" className="legal__brand display" aria-label="Bella 7 home">
          Bella <em>7</em>
        </Link>

        <div className="legal__head">
          <span className="mono legal__kicker">Last updated · {new Date().toLocaleDateString()}</span>
          <h1 className="display legal__heading">Privacy <em>policy</em>.</h1>
          <p className="legal__intro">
            We keep your information just as carefully as we'd want our own
            kept. This page explains what we collect, why, and what we do
            with it.
          </p>
        </div>

        <section className="legal__section">
          <h2>What we collect</h2>
          <p>
            When you book an appointment or send a message through the
            contact form, we collect your name, email, phone number, the
            service you've selected, and any notes you choose to share. We
            don't ask for payment information through this site.
          </p>
        </section>

        <section className="legal__section">
          <h2>How we use it</h2>
          <p>
            Your information is used to confirm your booking, send
            appointment reminders, reply to your questions, and run our
            day-to-day operations. We don't sell or share your information
            with third parties for advertising.
          </p>
        </section>

        <section className="legal__section">
          <h2>How long we keep it</h2>
          <p>
            Booking and message records are kept for as long as needed to
            run the business and meet our legal obligations. You can ask us
            to delete your records at any time by replying to a confirmation
            email.
          </p>
        </section>

        <section className="legal__section">
          <h2>Cookies</h2>
          <p>
            We use a single session cookie for staff login on the admin
            side. The public booking site does not set tracking cookies.
          </p>
        </section>

        <section className="legal__section">
          <h2>Your rights</h2>
          <p>
            You have the right to ask what we hold about you, to correct
            anything that's wrong, and to ask us to delete your records.
            Reach out through the contact form and we'll handle it.
          </p>
        </section>

        <section className="legal__section">
          <h2>Contact</h2>
          <p>
            Questions about this policy? Send a note through the
            <Link to="/#contact"> contact form </Link>
            and we'll get back to you within one business day.
          </p>
        </section>

        <Link to="/" className="legal__back">← Back to home</Link>
      </div>
    </div>
  );
}